"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1217],{

/***/ 13086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgEditIconBlue(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M.661 12a.658.658 0 01-.485-.215.65.65 0 01-.173-.503l.16-1.774 7.453-7.452 2.33 2.329-7.451 7.451-1.774.161a.651.651 0 01-.06.003zm9.75-8.08l-2.33-2.33L9.479.193a.658.658 0 01.931 0l1.397 1.397a.659.659 0 010 .932L10.41 3.918v.001z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgEditIconBlue);

/***/ }),

/***/ 3545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextCTA; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/fontSize.js
var fontSize = __webpack_require__(99420);
// EXTERNAL MODULE: ../core-ui/dist/constants/theme.js
var theme = __webpack_require__(63298);
// EXTERNAL MODULE: ../core-ui/dist/constants/files.js
var files = __webpack_require__(65357);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
;// CONCATENATED MODULE: ../core-ui/dist/components/TextCTA/TextCTA.styles.js









const StyledTextCTA = styled_components_browser_esm/* default.button */.ZP.button `
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    outline: inherit;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    color: ${({ color }) => color};
    font-family: ${({ weight }) => weight && fonts/* default */.Z[weight.toUpperCase()]};
    display: inline-flex;
    align-items: center;
    gap: 2px;
    line-height: 1.5;
    font-size: ${({ size }) => (size ? `${fontSize/* default */.Z[size]}rem` : "inherit")};
    text-decoration: ${({ underline }) => underline && "underline"};
    text-underline-offset: 2px;
`;


//# sourceMappingURL=TextCTA.styles.js.map

// EXTERNAL MODULE: ../core-ui/dist/hooks/useGenericAsyncHandler.js
var useGenericAsyncHandler = __webpack_require__(20475);
;// CONCATENATED MODULE: ../core-ui/dist/components/TextCTA/TextCTA.js






const TextCTA = (0,react.forwardRef)((props, ref) => {
    const { children, disabled, color = colors/* default.BLUE */.Z.BLUE, id, weight = "bold", iconNode, size = "s", underline, type = "button", } = props;
    const asynHandler = (0,useGenericAsyncHandler/* useGenericAsyncHandler */.L)(props === null || props === void 0 ? void 0 : props.onClick);
    return ((0,jsx_runtime.jsxs)(StyledTextCTA, Object.assign({ id: id, color: color, weight: weight, size: size, disabled: disabled || (asynHandler === null || asynHandler === void 0 ? void 0 : asynHandler.loading), underline: underline, type: type }, ((props === null || props === void 0 ? void 0 : props.onClick) && {
        onClick: asynHandler === null || asynHandler === void 0 ? void 0 : asynHandler.execute,
    }), { children: [iconNode, " ", children] })));
});


//# sourceMappingURL=TextCTA.js.map


/***/ }),

/***/ 14342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _TextCTA_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _TextCTA_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3545);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 95671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ LoginScope; },
/* harmony export */   "V": function() { return /* binding */ useSendOTP; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var _hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37528);
/* harmony import */ var _hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36153);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41634);
/* harmony import */ var _hooks_queryNames_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49352);
/* harmony import */ var _methods_encryptData_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57302);







var LoginScope;
(function (LoginScope) {
    LoginScope[LoginScope["LOGIN"] = 0] = "LOGIN";
    LoginScope[LoginScope["BOS"] = 1] = "BOS";
    LoginScope[LoginScope["ALT"] = 2] = "ALT";
    LoginScope[LoginScope["LOAD_VERIFICATION"] = 3] = "LOAD_VERIFICATION";
})(LoginScope || (LoginScope = {}));
function useSendOTP() {
    const { POST } = (0,_hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const sendOTP = ({ phoneNumber, scope, isWhatsApp = false }) => (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        const config = {
            key: "bf2f88919c968dc2c50410f26444efe1",
            iv: "c50410f26444efe1"
        };
        const meta = (0,_methods_encryptData_js__WEBPACK_IMPORTED_MODULE_5__/* .encryptData */ .q)({ phone_number: String(phoneNumber), time_stamp: Date.now(), source: "send_otp" }, config);
        return POST(_const_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].OTP */ .Z.OTP, {
            phone_number: String(phoneNumber),
            scope,
            request_meta_data: meta,
            is_whatsapp: isWhatsApp
        });
    });
    return (0,_hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_1__/* .useVahakMutationQuery */ .M8)(_hooks_queryNames_js__WEBPACK_IMPORTED_MODULE_4__/* .QueryNames.auth.sendOTP */ ._.auth.sendOTP, sendOTP);
}


//# sourceMappingURL=sms.service.js.map


/***/ }),

/***/ 36087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ useAuth; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
;// CONCATENATED MODULE: ../core/dist/methods/createCustomEvents.js
function createCustomEvents({ eventName, data }) {
    const event = new Event(eventName, data);
    document.dispatchEvent(event);
}


//# sourceMappingURL=createCustomEvents.js.map

// EXTERNAL MODULE: ../core/dist/_services/hooks/useUserProfileService.js
var useUserProfileService = __webpack_require__(84327);
// EXTERNAL MODULE: ../core/dist/_services/auth.adminConsole.service.js
var auth_adminConsole_service = __webpack_require__(72207);
// EXTERNAL MODULE: ../core/dist/_services/auth.service.js + 2 modules
var auth_service = __webpack_require__(68381);
// EXTERNAL MODULE: ../core/dist/_services/user-analytics.service.js
var user_analytics_service = __webpack_require__(8880);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core/dist/_services/sms.service.js
var sms_service = __webpack_require__(95671);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakHttpClient.js
var useVahakHttpClient = __webpack_require__(36153);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakQueryClient.js
var useVahakQueryClient = __webpack_require__(37528);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
// EXTERNAL MODULE: ../core/dist/_services/hooks/queryNames.js
var queryNames = __webpack_require__(49352);
;// CONCATENATED MODULE: ../core/dist/_services/whatsapp-otp.service.js





const useSendWhatsappOTP = () => {
    const { GET } = (0,useVahakHttpClient/* default */.Z)();
    function sendWaOTP(params) {
        const { phoneNumber } = params;
        return GET(_services_const/* default.OTP_VIA_WHATSAPP */.Z.OTP_VIA_WHATSAPP + phoneNumber);
    }
    return (0,useVahakQueryClient/* useVahakMutationQuery */.M8)([queryNames/* QueryNames.auth.sendWaOTP */._.auth.sendWaOTP], sendWaOTP);
};


//# sourceMappingURL=whatsapp-otp.service.js.map

;// CONCATENATED MODULE: ../core/dist/components/auth/useAuth.js













function useAuth({ phoneNum, otp, name, serviceType, whatsappUpdatesEnabled, placeId, isInitiatedFrom, referralCode, otpScope, user_joining_bonus_enabled }) {
    const { setPhoneNum, setName, setCompanyId, isPhoneVerified, setIsPhoneVerified, setCompanyLocation, setCompanyLogo, setUserId, userId, setServiceType, lang, setLang, setCsDashboardUserRoles, isCsDashboardUser, sessionId, setSessionId } = (0,react.useContext)(app_context/* AppContext */.Il);
    const { mutateAsync: updateCompanyDetails } = (0,useUserProfileService/* useUpdateCompanyDetails */.JK)();
    const { mutate: sendOTP } = (0,sms_service/* useSendOTP */.V)();
    const { mutate: sendWaOTP } = useSendWhatsappOTP();
    const onSubmitPhoneNum = (storePhoneNum = true) => (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
        if (!phoneNum) {
            // isPhoneVerified removed
            return;
        }
        !!storePhoneNum && (setPhoneNum === null || setPhoneNum === void 0 ? void 0 : setPhoneNum(phoneNum));
        sendOTP({ phoneNumber: phoneNum, scope: otpScope }, {
            onSuccess: (res) => {
                if (res && res.data && res.data.message) {
                    toast/* toast.success */.A.success(res.data.message);
                }
                else {
                    toast/* toast.success */.A.success("OTP sent successfully!");
                }
            },
            onError: (res) => {
                if (res && res.message) {
                    toast/* toast.error */.A.error(res.message);
                }
                else {
                    toast/* toast.error */.A.error("Error! Could not send the OTP.");
                }
            }
        });
    });
    const sendOtpViaWhatsapp = ({ onSuccessCallback, onSettledCallback }) => (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
        if (!phoneNum) {
            onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            return false;
        }
        sendWaOTP({ phoneNumber: phoneNum }, {
            onSuccess: (res) => {
                if (res && res.data && res.data.message) {
                    toast/* toast.success */.A.success(res.data.message);
                }
                else {
                    toast/* toast.success */.A.success("OTP sent successfully!");
                }
                onSuccessCallback();
                onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            },
            onError: (res) => {
                if (res && res.message) {
                    toast/* toast.error */.A.error(res.message);
                }
                else {
                    toast/* toast.error */.A.error("Error! Could not send the OTP.");
                }
                onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            }
        });
        return false;
    });
    const onClickResendOtp = ({ isWhatsApp = false, onSuccessCallback, onSettledCallback }) => (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
        if (!phoneNum) {
            onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            return false;
        }
        sendOTP({ phoneNumber: phoneNum, scope: otpScope, isWhatsApp }, {
            onSuccess: (res) => {
                if (res && res.data && res.data.message) {
                    toast/* toast.success */.A.success(res.data.message);
                }
                else {
                    toast/* toast.success */.A.success("OTP sent successfully!");
                }
                onSuccessCallback();
                onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            },
            onError: (res) => {
                if (res && res.message) {
                    toast/* toast.error */.A.error(res.message);
                }
                else {
                    toast/* toast.error */.A.error("Error! Could not send the OTP.");
                }
                onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            }
        });
        return false;
    });
    const addLoginOrRegisterSuccessfullEvent = () => {
        createCustomEvents({ eventName: misc/* CUSTOM_EVENTS.LOGGEDIN */.fD.LOGGEDIN });
    };
    const onSubmitOtp = (override) => (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const resolvedPhoneNum = (_a = override === null || override === void 0 ? void 0 : override.phoneNum) !== null && _a !== void 0 ? _a : phoneNum;
        const resolvedOtp = (_b = override === null || override === void 0 ? void 0 : override.otp) !== null && _b !== void 0 ? _b : otp;
        if (!resolvedPhoneNum || !resolvedOtp) {
            return;
        }
        const { data } = yield auth_service/* AuthService.loginViaOtp */.e8.loginViaOtp({
            phone_number: resolvedPhoneNum,
            otp: resolvedOtp,
            is_wa_optin: whatsappUpdatesEnabled
        });
        setSessionId === null || setSessionId === void 0 ? void 0 : setSessionId(data === null || data === void 0 ? void 0 : data.session_id);
        // User model exists
        if (data) {
            if (isCsDashboardUser) {
                const userRoles = yield auth_adminConsole_service/* AuthServiceAdminConsole.getUserRoles */.Dh.getUserRoles(data.u_id);
                if (userRoles === null || userRoles === void 0 ? void 0 : userRoles.id) {
                    userRoles && (setCsDashboardUserRoles === null || setCsDashboardUserRoles === void 0 ? void 0 : setCsDashboardUserRoles(userRoles.roles));
                }
                else {
                    toast/* toast.error */.A.error("No access, Please reach out to manager.");
                }
            }
            // login
            setIsPhoneVerified === null || setIsPhoneVerified === void 0 ? void 0 : setIsPhoneVerified(true);
            setName === null || setName === void 0 ? void 0 : setName(data.c_name);
            setCompanyId === null || setCompanyId === void 0 ? void 0 : setCompanyId(data.c_id);
            setCompanyLocation === null || setCompanyLocation === void 0 ? void 0 : setCompanyLocation(data.c_loc);
            setUserId === null || setUserId === void 0 ? void 0 : setUserId(data.u_id);
            if (lang) {
                (0,useUserProfileService/* handleUpdateCompanyDetails */.IP)(updateCompanyDetails, {
                    companyId: data === null || data === void 0 ? void 0 : data.c_id,
                    languageCode: lang
                });
            }
            else {
                setLang === null || setLang === void 0 ? void 0 : setLang(data.lang);
            }
            setCompanyLogo === null || setCompanyLogo === void 0 ? void 0 : setCompanyLogo(data === null || data === void 0 ? void 0 : data.profile_image);
            if (data.c_serv)
                setServiceType === null || setServiceType === void 0 ? void 0 : setServiceType(data.c_serv);
            if (data.c_id) {
                const eventID = (0,user_analytics_service/* getFBEventId */.$Y)("login", data === null || data === void 0 ? void 0 : data.c_id);
                (_c = window.fbq) === null || _c === void 0 ? void 0 : _c.call(window, "track", "AddToCart", { phoneNum }, { eventID });
                // sendFbCapiEvent({ event_id: eventID, event_name: "AddToCart", phone_num: phoneNum });
                (0,user_analytics_service/* sendPageSenseEvent */.j5)("Login Success");
            }
            else {
                // User Registration
                const eventID = (0,user_analytics_service/* getFBEventId */.$Y)("register", data === null || data === void 0 ? void 0 : data.u_id);
                (_d = window.fbq) === null || _d === void 0 ? void 0 : _d.call(window, "track", "AddToWishlist", { phoneNum }, { eventID });
                // sendFbCapiEvent({ event_id: eventID, event_name: "AddToWishlist", phone_num: phoneNum });
                (0,user_analytics_service/* sendPageSenseEvent */.j5)("User Registration Succes");
            }
            (0,user_analytics_service/* ga4SetUser */.LS)(data.u_id);
            addLoginOrRegisterSuccessfullEvent();
            return {
                status: true,
                companyName: data.c_name,
                companyId: data.c_id,
                serviceType: data.c_serv,
                userId: data.u_id,
                createdAt: data.user_created_at
            };
        }
    });
    const onSubmitCompanyDetails = (override) => (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
        var _e, _f, _g, _h, _j;
        const resolvedName = (_e = override === null || override === void 0 ? void 0 : override.name) !== null && _e !== void 0 ? _e : name;
        const resolvedUserId = (_f = override === null || override === void 0 ? void 0 : override.userId) !== null && _f !== void 0 ? _f : userId;
        const resolvedServiceType = (_g = override === null || override === void 0 ? void 0 : override.serviceType) !== null && _g !== void 0 ? _g : serviceType;
        const resolvedPlaceId = (_h = override === null || override === void 0 ? void 0 : override.placeId) !== null && _h !== void 0 ? _h : placeId;
        // company sign up
        if (!resolvedName || !resolvedUserId || !resolvedServiceType) {
            return;
        }
        setName === null || setName === void 0 ? void 0 : setName(resolvedName);
        const data = yield auth_service/* AuthService.registerCompanyDetails */.e8.registerCompanyDetails({
            userId: parseInt(String(resolvedUserId), 10),
            name: resolvedName,
            serviceType: resolvedServiceType,
            placeId: resolvedPlaceId || "",
            referralCode: referralCode,
            sessionId: sessionId,
            user_joining_bonus_enabled
        });
        if (!data) {
            toast/* toast.error */.A.error("Something went wrong, Please try again later or contact customer support!");
            return { status: false, companyName: null, companyId: null };
        }
        /**
         * As this is the last step,
         * here is where we complete the signup process
         */
        setCompanyId === null || setCompanyId === void 0 ? void 0 : setCompanyId(data === null || data === void 0 ? void 0 : data.c_id);
        if (lang) {
            (0,useUserProfileService/* handleUpdateCompanyDetails */.IP)(updateCompanyDetails, {
                companyId: data === null || data === void 0 ? void 0 : data.c_id,
                languageCode: lang
            });
        }
        setCompanyLogo === null || setCompanyLogo === void 0 ? void 0 : setCompanyLogo(data === null || data === void 0 ? void 0 : data.profile_image);
        setServiceType === null || setServiceType === void 0 ? void 0 : setServiceType(resolvedServiceType);
        const eventID = (0,user_analytics_service/* getFBEventId */.$Y)("signup", data === null || data === void 0 ? void 0 : data.c_id);
        (_j = window.fbq) === null || _j === void 0 ? void 0 : _j.call(window, "track", "CompleteRegistration", { phoneNum }, { eventID });
        // sendFbCapiEvent({ event_id: eventID, event_name: "CompleteRegistration", phone_num: phoneNum });
        (0,user_analytics_service/* sendPageSenseEvent */.j5)("Signup Succes");
        return {
            status: true,
            companyName: data.c_name,
            companyId: data.c_id,
            userId: data.u_id,
            createdAt: data.user_created_at
        };
    });
    return {
        onSubmitPhoneNum,
        onClickResendOtp,
        onSubmitOtp,
        onSubmitCompanyDetails,
        sendOtpViaWhatsapp
    };
}


//# sourceMappingURL=useAuth.js.map


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useGetLorryMarketV2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36153);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_methods_generateUrlParamsFromArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73435);
/* harmony import */ var _vahak_core_dist_methods_generateUrlParamsFromObject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13521);
/* harmony import */ var _queryNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9433);








/**
 * Need to get rid of LorryMarketDetails (type)
 */ /**
 * Lorry market v2 api
 * @param param0
 * @param options
 * @returns
 */ var useGetLorryMarketV2 = function(param, options) {
    var page = param.page, c_i = param.c_i, lorry_type_id = param.lorry_type_id, city_id = param.city_id, state_id = param.state_id, destination_city_id = param.destination_city_id, destination_state_id = param.destination_state_id, capacity_string = param.capacity_string, l = param.l, preloads = param.preloads, vehicle_verified_only = param.vehicle_verified_only, connections_only = param.connections_only, lorry_type_counts = param.lorry_type_counts, membership_user_filter = param.membership_user_filter, payment_linked_only = param.payment_linked_only, lorryId = param.lorryId, destination_place_id = param.destination_place_id, source_place_id = param.source_place_id;
    var GET = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().GET;
    var payload = {
        page: page,
        c_i: c_i,
        lorry_type_id: lorry_type_id,
        city_id: city_id,
        state_id: state_id,
        destination_city_id: destination_city_id,
        destination_state_id: destination_state_id,
        capacity_string: capacity_string,
        l: l,
        vehicle_verified_only: vehicle_verified_only,
        connections_only: connections_only,
        lorry_type_counts: lorry_type_counts,
        membership_user_filter: membership_user_filter,
        payment_linked_only: payment_linked_only,
        lorryId: lorryId,
        destination_place_id: destination_place_id,
        source_place_id: source_place_id
    };
    var urlString = (0,_vahak_core_dist_methods_generateUrlParamsFromObject__WEBPACK_IMPORTED_MODULE_4__/* .generateUrlParamsFromObject */ .Z)(payload);
    var idString = lorryId && (0,_vahak_core_dist_methods_generateUrlParamsFromArray__WEBPACK_IMPORTED_MODULE_5__/* .generateUrlParamsFromArray */ .L)(lorryId, "id");
    var preloadsString = preloads && (0,_vahak_core_dist_methods_generateUrlParamsFromArray__WEBPACK_IMPORTED_MODULE_5__/* .generateUrlParamsFromArray */ .L)(preloads, "preloads");
    var getLorryMarketV2Data = function() {
        return GET("".concat(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_2__/* ["default"].LORRY_MARKET_V2 */ .Z.LORRY_MARKET_V2).concat(idString ? "&" + idString : "").concat(urlString).concat(preloadsString ? "&" + preloadsString : ""));
    };
    /**
     * If you don't know the error type pass unknown
     */ return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__/* .useVahakQuery */ .uE)([
        _queryNames__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getLorryMarketV2 */ .Z.getLorryMarketV2,
        payload
    ], getLorryMarketV2Data, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, options), {
        select: function(data) {
            return data.data;
        }
    }));
};


/***/ })

}]);